import { useMainStore } from "stores/main.store"


export default function () {  
    const ifDownloadModal = function(hashValue) {
        const splitHash = window.location.hash.split('=')
        
        if (splitHash[0] === '#download-modal') {
            const downloadPath = splitHash[1]
            const mainStore = useMainStore()
            const link = document.querySelector('a[href="' + hashValue + '"]')
            mainStore.setLeadGateData({ downloadPath: downloadPath, linkElement: link })
            mainStore.changeOverlaySettings({
                showOverlay: true, 
                overlayType: "leadGate", 
                content: {},
                closeCallback: () => {
                    window.location.hash = ''
                },
            })
        }
    }
    
    ifDownloadModal(window.location.hash)
    window.addEventListener('hashchange', function() {
        ifDownloadModal(window.location.hash)
    })
}